import { API_URL, getAuthHeaders } from './config';

export const authService = {
    login: async (credentials: any) => {
        const res = await fetch(`${API_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credentials)
        });
        if (!res.ok) throw new Error("Login failed");
        return res.json();
    },
    refreshToken: async () => {
        const res = await fetch(`${API_URL}/auth/refresh-token`, {
            method: 'POST',
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Refresh failed");
        return res.json();
    },
    register: async (inputData: any) => {
        const data = { ...inputData, terms_accepted: true }; // FORCE TRUE as a safety net
        console.log("REGISTER PAYLOAD (Final):", data); // DEBUG
        const res = await fetch(`${API_URL}/auth/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (res.status === 409) throw new Error("Cet email est déjà utilisé.");
        if (!res.ok) {
            let errorMessage = "Erreur d'inscription (" + res.status + ")";
            try {
                const errorBody = await res.json();
                if (errorBody.error) {
                    if (typeof errorBody.error === 'string') {
                        errorMessage = errorBody.error;
                    } else if (errorBody.error.issues) {
                        // Zod Error
                        errorMessage = errorBody.error.issues.map((i: any) => i.message).join(', ');
                    }
                }
            } catch (e) {
                // Ignorer si pas de JSON
            }
            throw new Error(errorMessage);
        }
        return res.json();
    },
    changePassword: async (data: any) => {
        const res = await fetch(`${API_URL}/auth/change-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to change password");
        return res.json();
    },
    forgotPassword: async (email: string) => {
        const res = await fetch(`${API_URL}/auth/forgot-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
        });
        if (!res.ok) throw new Error("Failed to send reset email");
        return res.json();
    },
    resetPassword: async (data: { token: string, newPassword: string }) => {
        const res = await fetch(`${API_URL}/auth/reset-password`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        if (!res.ok) throw new Error("Failed to reset password");
        return res.json();
    },
    searchUsers: async (query: string) => {
        const res = await fetch(`${API_URL}/users/search?q=${encodeURIComponent(query)}`, {
            headers: getAuthHeaders() // Needs import? No, auth service might not use it?
            // Actually search might need auth.
            // Let's check imports.
        });
        if (!res.ok) throw new Error("Failed to search users");
        const json = await res.json() as any;
        return json.data || json; // Handle wrapped or raw
    },
    // WebAuthn / Passkeys
    getWebAuthnRegistrationOptions: async () => {
        const res = await fetch(`${API_URL}/auth/webauthn/register-options`, {
            headers: getAuthHeaders()
        });
        if (!res.ok) throw new Error("Failed to get registration options");
        return res.json();
    },
    verifyWebAuthnRegistration: async (credential: any) => {
        const res = await fetch(`${API_URL}/auth/webauthn/register-verify`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(credential)
        });
        if (!res.ok) throw new Error("Verification failed");
        return res.json();
    },
    getWebAuthnLoginOptions: async (email?: string) => {
        const res = await fetch(`${API_URL}/auth/webauthn/login-options${email ? `?email=${encodeURIComponent(email)}` : ''}`);
        if (!res.ok) throw new Error("Failed to get login options");
        return res.json();
    },
    verifyWebAuthnLogin: async (credential: any, email?: string) => {
        const res = await fetch(`${API_URL}/auth/webauthn/login-verify${email ? `?email=${encodeURIComponent(email)}` : ''}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(credential)
        });
        if (!res.ok) throw new Error("Login verification failed");
        return res.json();
    },
    socialLogin: async (provider: 'google' | 'outlook' | 'facebook', code: string, redirect_uri: string, state?: string) => {
        const res = await fetch(`${API_URL}/auth/social/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ provider, code, redirect_uri, state })
        });
        if (!res.ok) throw new Error("Social login failed");
        return res.json();
    },
    getSocialAuthUrl: async (provider: 'google' | 'outlook' | 'facebook', redirectUrl: string, state?: string) => {
        const res = await fetch(`${API_URL}/auth/social/url?provider=${provider}&redirect_url=${encodeURIComponent(redirectUrl)}${state ? `&state=${encodeURIComponent(state)}` : ''}`);
        if (!res.ok) throw new Error("Failed to get auth URL");
        return res.json() as Promise<{ url: string }>;
    }
};
